/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Container } from 'react-bootstrap';
import api from '../../../services/API';
import historico from '../../../services/Historico';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import sortFunc from '../../../utils/ordernarColunaInt';
import moment from 'moment-timezone';
import sortFuncDate from '../../../utils/ordernarColunaDate';
import Toggle from 'react-bootstrap-toggle';
import { toast } from 'react-toastify';
import ModalExcluir from './ModalExcluir/index';
import ModalEditar from './ModalEditar/index';
import ModalAtivarAviso from './ModalAtivarAviso/index';
import { useSelector } from 'react-redux';


export default function Parceiros() {
  const usuario = useSelector((state) => {
    return state.usuario;
  });

  const columns = [
    {
      dataField: 'nome',
      text: 'Vendedor',
      sort: true,
      formatter: (celula, valor) => {
        return (
          <button
            className="btn-limpo"
            onClick={(e) => {
              e.preventDefault();
              historico.push(`parceiro/${valor.cpf}`);
            }}
          >
            <b>{valor.nome}</b>
          </button>
        );
      },
    },
    {
      dataField: 'cpf',
      text: 'CPF',
      formatter: (celula, valor) => {
        let cpf = valor.cpf.replace(/[^\d]/g, '');
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'gestor',
      text: 'Gestor',
      sort: true,
      formatter: (celula, valor) => {
        return valor.gestor || 'Não definido';
      },
    },
    {
      dataField: 'celular',
      text: 'Celular',
      formatter: (celula, valor) => {
        return `(${valor.celular.substring(0, 2)}) ${valor.celular.substring(
          2,
          7
        )}-${valor.celular.substring(7)}`;
      },
      sort: true,
    },
    {
      dataField: 'endCidade',
      text: 'Cidade',
      sort: true,
    },
    {
      text: 'Loja',
      dataField: 'revenda',
      sort: true,
    },
    {
      text: 'Código Loja',
      dataField: 'codRevenda',
      sort: true,
    },
    {
      dataField: 'totalPontos',
      text: 'Pontuação Total',
      formatter: (celula, valor) => {
        return Number(valor.totalPontos).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'saldoPontos',
      text: 'Saldo de Pontos',
      formatter: (celula, valor) => {
        return Number(valor.saldoPontos).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      text: 'Última Pontuação',
      dataField: 'ultimaPontuacao',
      formatter: (celula, valor) => {
        return valor.ultimaPontuacao && valor.ultimaPontuacao !== 0
          ? moment(valor.ultimaPontuacao).format('DD/MM/YYYY HH:mm:ss')
          : '-';
      },
      sort: true,
      sortFunc: sortFuncDate,
    },
    {
      text: 'Último Acesso',
      dataField: 'ultimoAcessoEm',
      formatter: (celula, valor) => {
        return valor.ultimoAcessoEm && valor.ultimoAcessoEm !== 0
          ? moment(valor.ultimoAcessoEm).format('DD/MM/YYYY HH:mm:ss')
          : '-';
      },
      sort: true,
      sortFunc: sortFuncDate,
    },
    {
      text: 'Dias Sem Acessar',
      dataField: 'ultimoAcessoEm',
      formatter: (celula, valor) => {
        const hoje = new Date();
        const ultimoAcesso = new Date(valor.ultimoAcessoEm);
        const diferencaTempo = Math.abs(hoje - ultimoAcesso);
        const diferencaDias = Math.floor(diferencaTempo / (1000 * 60 * 60 * 24));

         if(diferencaDias.toFixed(0) >= 19193) return '-';
        return diferencaDias.toFixed(0);
      },
      sort: true,
      sortFunc: sortFuncDate,
    },
    // {
    //   text: 'Hobby Favorito',
    //   dataField: 'hobby',
    //   sort: true,
    // },
    {
      isDummyField: true,
      dataField: 'ativo',
      text: 'Ativo',
      sort: true,
      hidden: [2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => {
        const temRevendaOuRedeInativa = 
          (valor.revendaAtivo !== undefined && valor.revendaAtivo !== 1) ||
          (valor.redeAtivo !== undefined && valor.redeAtivo !== 1);
        
        let tooltipText = '';
        if (valor.revendaAtivo !== undefined && valor.revendaAtivo !== 1 && 
            valor.redeAtivo !== undefined && valor.redeAtivo !== 1) {
          tooltipText = 'Este vendedor possui revenda e rede inativas. Ao ativar o vendedor, ambas serão ativadas automaticamente.';
        } else if (valor.revendaAtivo !== undefined && valor.revendaAtivo !== 1) {
          tooltipText = 'Este vendedor possui revenda inativa. Ao ativar o vendedor, a revenda será ativada automaticamente.';
        } else if (valor.redeAtivo !== undefined && valor.redeAtivo !== 1) {
          tooltipText = 'Este vendedor possui rede inativa. Ao ativar o vendedor, a rede será ativada automaticamente.';
        }
        
        const iconInfo = temRevendaOuRedeInativa ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${valor.id}`}>{tooltipText}</Tooltip>}
          >
            <i
              className="fas fa-info-circle ml-2"
              style={{ color: '#ffc107', cursor: 'help' }}
            />
          </OverlayTrigger>
        ) : null;
        
        const ativoTexto = valor.ativo === 1 ? 'Sim' : 'Não';
        return (
          <div className="d-flex align-items-center justify-content-center" style={{ position: 'relative' }}>
            <Toggle
              onClick={(state) => updateStatus(state, valor.id, valor)}
              on={<span>Sim</span>}
              off={<span>Não</span>}
              size="sm"
              offstyle="danger"
              active={valor.ativo === 1 ? true : false}
            />
            <span
              style={{
                position: 'absolute',
                inset: 0,
                opacity: 0,
                pointerEvents: 'none',
                overflow: 'hidden',
              }}
            >
              {ativoTexto}
            </span>
            {iconInfo}
          </div>
        );
      },
    },
    {
      dataField: 'editar',
      isDummyField: true,
      text: 'Editar',
      sort: false,
      hidden: [1, 2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            abrirModalEditar(valor.id);
          }}
        >
          <i className="fas fa-edit"></i>
        </button>
      ),
    },
    {
      dataField: 'apagar',
      isDummyField: true,
      text: 'Apagar',
      sort: false,
      hidden: [2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            abrirModalExcluir(valor.id, valor.nome);
          }}
        >
          <i className="fas fa-trash f-red"></i>
        </button>
      ),
    },
  ];

  const [data, setData] = useState([]);
  const [redesSelect, setRedesSelect] = useState([]);
  const [redeSelecionada, setRedeSelecionada] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [pagination, setPagination] = useState({
    nextCursor: null,
    prevCursor: null,
    hasNext: false,
    hasPrev: false,
    limit: 10,
    totalCount: 0,
    currentPage: 1,
  });

  const [dataEditar, setDataEditar] = useState(null);
  const [id, setId] = useState('');
  const [parceiro, setParceiro] = useState('');
  const [mostrarModalExcluir, setMostrarModalExcluir] = useState(false);
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
  const [mostrarModalAtivarAviso, setMostrarModalAtivarAviso] = useState(false);
  const [parceiroParaAtivar, setParceiroParaAtivar] = useState(null);

  const [gestorSelecionado, setGestorSelecionado] = useState('');
  const [gestoresSelect, setGestoresSelect] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [sortState, setSortState] = useState({ sortField: 'nome', sortOrder: 'asc' });
  const defaultSorted = [{ dataField: sortState.sortField, order: sortState.sortOrder }];
  const isLimitAll = (l) => l === 0 || l === 'all' || l == null;

  const buscarParceiros = async (cursor = null, direction = 'next', limitParaUsar = null, search = '', sort = null) => {
    setBuscando(true);
    const effectiveLimit = limitParaUsar ?? pagination.limit;
    const useAll = isLimitAll(effectiveLimit);
    let params = {
      rede: redeSelecionada,
      limit: useAll ? 'all' : effectiveLimit,
    };
    if (usuario.permissao !== 2) {
      params.ativo = 1;
    }
    if (gestorSelecionado) {
      params.gestorNome = gestorSelecionado;
    }
    if (search) {
      params.search = search;
    }
    const effectiveSort = sort ?? sortState;
    if (effectiveSort?.sortField) {
      params.sortField = effectiveSort.sortField;
      params.sortOrder = effectiveSort.sortOrder || 'asc';
    }
    if (!cursor || useAll) {
      params.includeCount = 'true';
    }
    if (cursor && !useAll) {
      params.cursor = cursor;
      params.direction = direction;
    }
    const searchParams = new URLSearchParams(params);

    const resultado = await api.get(
      `/api/parceiros?${searchParams.toString()}`
    );
    if (resultado) {
      setData(resultado.data.parceiros);
      if (resultado.data.pagination) {
        const pag = resultado.data.pagination;
        const limit = pag.limit == null ? 0 : pag.limit;
        setPagination(prev => ({
          nextCursor: pag.nextCursor ?? null,
          prevCursor: pag.prevCursor ?? null,
          hasNext: pag.hasNext ?? false,
          hasPrev: pag.hasPrev ?? false,
          limit,
          totalCount: pag.totalCount != null ? pag.totalCount : prev.totalCount,
          currentPage: pag.currentPage ?? prev.currentPage ?? 1,
        }));
      }
    }

    setBuscando(false);
  };

  const buscarRedes = async () => {
    let todasRedes = [];
    let cursor = null;
    let hasNext = true;
    
    while (hasNext) {
      const url = cursor 
        ? `/api/redes?limit=100&cursor=${cursor}&direction=next`
        : '/api/redes?limit=100';
      
      const resultado = await api.get(url);
      if (resultado && resultado.data.redes) {
        todasRedes = [...todasRedes, ...resultado.data.redes];
        hasNext = resultado.data.pagination?.hasNext || false;
        cursor = resultado.data.pagination?.nextCursor || null;
      } else {
        hasNext = false;
      }
    }
    
    setRedesSelect(todasRedes);
  };

  const buscarGestores = async () => {
    const resultado = await api.get('/api/gestores');
    if (resultado) {
      setGestoresSelect(resultado.data);
    }
  };

  useEffect(() => {
    buscarRedes();
    buscarParceiros(null, 'next', pagination.limit);
    buscarGestores(); 
  }, []);

  useEffect(() => {
    if (buscando) {
      setData([]);
    }
  }, [buscando]);

  const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    if (type === 'sort' && sortField) {
      setSortState({ sortField, sortOrder: sortOrder || 'asc' });
      setPagination(prev => ({ ...prev, currentPage: 1, nextCursor: null, prevCursor: null, hasNext: false, hasPrev: false }));
      buscarParceiros(null, 'next', pagination.limit, searchText, { sortField, sortOrder: sortOrder || 'asc' });
      return;
    }
    if (type === 'pagination') {
      const currentPage = page || 1;
      const newLimit = sizePerPage !== undefined && sizePerPage !== null ? sizePerPage : pagination.limit;
      const isSameAsTodos = pagination.limit === 0 && newLimit === pagination.totalCount;
      const limitChanged = newLimit !== pagination.limit && !isSameAsTodos;

      if (limitChanged) {
        setPagination(prev => ({ 
          ...prev, 
          limit: newLimit, 
          currentPage: 1,
          nextCursor: null,
          prevCursor: null,
          hasNext: false,
          hasPrev: false,
        }));
        buscarParceiros(null, 'next', isLimitAll(newLimit) ? 0 : newLimit, searchText);
        return;
      }
      if (currentPage === 1) {
        setPagination(prev => ({ 
          ...prev, 
          currentPage: 1,
          nextCursor: null,
          prevCursor: null,
          hasNext: false,
          hasPrev: false,
        }));
        buscarParceiros(null, 'next', isLimitAll(pagination.limit) ? 0 : pagination.limit, searchText);
      } else {
        const direction = currentPage > pagination.currentPage ? 'next' : 'prev';
        const cursor = direction === 'next' ? pagination.nextCursor : pagination.prevCursor;
        if (cursor) {
          setPagination(prev => ({ ...prev, currentPage }));
          buscarParceiros(cursor, direction, isLimitAll(pagination.limit) ? 0 : pagination.limit, searchText);
        } else {
          setPagination(prev => ({ ...prev, currentPage: prev.currentPage }));
        }
      }
    }
  };

  const options = {
    page: pagination.currentPage,
    sizePerPage: isLimitAll(pagination.limit) ? (pagination.totalCount || 10) : pagination.limit,
    totalSize: pagination.totalCount,
    showTotal: true,
    sizePerPageList: [
      { text: '10', value: 10 },
      { text: '50', value: 50 },
      { text: '100', value: 100 },
      { text: 'Todos', value: isLimitAll(pagination.limit) ? pagination.totalCount : 0 },
    ],
    paginationTotalRenderer: (from, to, size) =>
      pagination.totalCount > 0 ? (
        <span className="react-bootstrap-table-pagination-total px-2">
          {from}-{to} de {pagination.totalCount} resultados
        </span>
      ) : (
        <span className="react-bootstrap-table-pagination-total px-2">
          Nenhum resultado
        </span>
      ),
    onPageChange: (page, sizePerPage) => {
      handleTableChange('pagination', { page, sizePerPage });
    },
    onSizePerPageChange: (page, sizePerPage) => {
      handleTableChange('pagination', { page, sizePerPage });
    },
  };

  async function updateStatus(state, id, parceiroData = null) {
    // Se estiver desativando, apenas desativa normalmente
    if (!state) {
      const resultado = await api.put(`/api/parceiros/${id}`, {
        ativo: 0,
      });

      if (resultado) {
        toast.success('Parceiro atualizado com sucesso', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
        });
      }

      setData(
        data.map((d) => {
          if (d.id === id) {
            d.ativo = 0;
            d = {...d, diasSemAcessar: d.ultimoAcessoEm}
          }
          return d;
        })
      );
      return;
    }

    // Se estiver ativando, verificar se precisa mostrar modal
    const parceiro = parceiroData || data.find((d) => d.id === id);
    const temRevendaOuRedeInativa = 
      (parceiro && parceiro.revendaAtivo !== undefined && parceiro.revendaAtivo !== 1) ||
      (parceiro && parceiro.redeAtivo !== undefined && parceiro.redeAtivo !== 1);

    if (temRevendaOuRedeInativa) {
      setParceiroParaAtivar({ id, state });
      setMostrarModalAtivarAviso(true);
    } else {
      confirmarAtivacao(id, state);
    }
  }

  const confirmarAtivacao = async (id, state) => {
    const resultado = await api.put(`/api/parceiros/${id}`, {
      ativo: state ? 1 : 0,
    });

    if (resultado) {
      toast.success('Parceiro atualizado com sucesso', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });
    }

    setData(
      data.map((d) => {
        if (d.id === id) {
          d.ativo = state ? 1 : 0;
          d.revendaAtivo = 1;
          d.redeAtivo = 1;
          d = {...d, diasSemAcessar: d.ultimoAcessoEm}
        }
        return d;
      })
    );
    setMostrarModalAtivarAviso(false);
    setParceiroParaAtivar(null);
  };

  const fecharModalAtivarAviso = () => {
    setMostrarModalAtivarAviso(false);
    setParceiroParaAtivar(null);
  };

  const abrirModalExcluir = (id, parceiro) => {
    setParceiro(parceiro);
    setId(id);
    setMostrarModalExcluir(true);
  };

  const fecharModalExcluir = () => {
    setParceiro('');
    setId('');
    setMostrarModalExcluir(false);
  };

  const abrirModalEditar = (id) => {
    const dados = data.filter((d) => d.id === id);
    setDataEditar(dados[0]);
    setMostrarModalEditar(true);
  };

  const fecharModalEditar = () => {
    setDataEditar([]);
    setMostrarModalEditar(false);
  };

  const atualizarExclusao = (id) => {
    setData(data.filter((d) => d.id !== id));
  };

  const atualizarParceiro = (dataUpdated) => {
    setData(
      data.map((d) => {
        if (d.id === dataUpdated.id) {
          d = { ...d, ...dataUpdated };
        }
        return d;
      })
    );
  };

  return (
    <Container fluid>
      <h4 className="pt-3 pb-3 f-black">Vendedores Lojas</h4>
      <hr className="hr-loja mt-0 mb-4" />
      <Row>
        <Col xs={12} sm={12} md={6} lg={4} xl={3} className="d-flex flex-column mb-3">
          <label htmlFor="redeSelecionada">Selecione uma Rede</label>
          <select
            className="input-select"
            name="redeSelecionada"
            id="redeSelecionada"
            onChange={(e) => setRedeSelecionada(e.target.value)}
            defaultValue=""
            placeholder=""
            style={{ width: '100%' }}
          >
            <option value="">Todas</option>
            {redesSelect.map((rede) => (
              <option value={rede.nome} key={rede.nome}>
                {rede.nome}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} xl={3} className="d-flex flex-column mb-3">
          <label htmlFor="gestorSelecionado">Selecione um Gestor</label>
          <select
            className="input-select"
            name="gestorSelecionado"
            id="gestorSelecionado"
            onChange={(e) => setGestorSelecionado(e.target.value)}
            defaultValue=""
            style={{ width: '100%' }}
          >
            <option value="">Todos</option>
            {gestoresSelect.map((gestor) => (
              <option value={gestor.id} key={gestor.id}>
                {gestor.nome}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} xl={3} className="d-flex flex-column justify-content-end mb-3">
          <button 
            className="btn-busca-filtro" 
            type="submit" 
            onClick={() => buscarParceiros(null, 'next', pagination.limit, searchText)}
          >
            {buscando ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-search"></i>
            )}
          </button>
        </Col>
      </Row>
      <div>
        <ToolkitProvider
          bootstrap4
          keyField="cpf"
          data={data}
          columns={columns}
        >
          {(props) => (
            <div>
              <div className="d-flex flex-row-reverse mb-3">
                <div className="d-flex align-items-center" style={{ width: '100%', maxWidth: '400px' }}>
                  <input
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        setPagination(prev => ({ 
                          ...prev, 
                          currentPage: 1,
                          nextCursor: null,
                          prevCursor: null,
                          hasNext: false,
                          hasPrev: false,
                        }));
                        buscarParceiros(null, 'next', pagination.limit, searchText);
                      }
                    }}
                    placeholder="Buscar"
                    className="input-theme mr-2"
                    style={{ flex: 1 }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      setPagination(prev => ({ 
                        ...prev, 
                        currentPage: 1,
                        nextCursor: null,
                        prevCursor: null,
                        hasNext: false,
                        hasPrev: false,
                      }));
                      buscarParceiros(null, 'next', pagination.limit, searchText);
                    }}
                    className="btn-busca"
                    style={{ marginBottom: 0, marginTop: 0, flexShrink: 0 }}
                  >
                    {buscando ? (
                      <i className="fas fa-circle-notch fa-spin"></i>
                    ) : (
                      <i className="fas fa-search"></i>
                    )}
                  </button>
                </div>
              </div>
              <BootstrapTable
                noDataIndication={() =>
                  buscando ? (
                    <span>
                      Carregando
                      <i className="fas fa-circle-notch fa-spin ml-3"></i>
                    </span>
                  ) : (
                    <span>Sem resultados</span>
                  )
                }
                classes="table-dark text-center rounded"
                wrapperClasses="rounded"
                bordered={false}
                pagination={paginationFactory(options)}
                remote={{ pagination: true, sort: true }}
                onTableChange={handleTableChange}
                defaultSorted={defaultSorted}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
      <ModalExcluir
        show={mostrarModalExcluir}
        onHide={fecharModalExcluir}
        parceiro={parceiro}
        id={id}
        atualizarExclusao={atualizarExclusao}
      />
      <ModalEditar
        show={mostrarModalEditar}
        onHide={fecharModalEditar}
        data={dataEditar}
        atualizarParceiro={atualizarParceiro}
      />
      {parceiroParaAtivar && (
        <ModalAtivarAviso
          show={mostrarModalAtivarAviso}
          onHide={fecharModalAtivarAviso}
          onConfirm={() => confirmarAtivacao(parceiroParaAtivar.id, parceiroParaAtivar.state)}
          revendaInativa={
            data.find((d) => d.id === parceiroParaAtivar.id)?.revendaAtivo !== 1
          }
          redeInativa={
            data.find((d) => d.id === parceiroParaAtivar.id)?.redeAtivo !== 1
          }
        />
      )}
    </Container>
  );
}
